import React, { useEffect } from 'react';
import { logEvent } from 'firebase/analytics';
import { getAnalytics } from 'firebase/analytics';
import app from '../services/firebase';

const PinterestRedirect = () => {
  const analytics = getAnalytics(app);
  const APP_STORE_URL = 'https://apps.apple.com/us/app/food-recipes-chef-kats/id6739225693';

  useEffect(() => {
    // Трекинг Pinterest редиректа
    const trackVisit = () => {
      try {
        // Firebase Analytics - четкие названия событий
        logEvent(analytics, 'PINTEREST_ROUTE_APP_STORE_REDIRECT', {
          source: 'pinterest_route',
          destination: 'app_store',
          timestamp: new Date().toISOString(),
          user_agent: navigator.userAgent,
          referrer: document.referrer,
          route: window.location.pathname
        });
        
        // Счетчик Pinterest переходов в App Store
        logEvent(analytics, 'PINTEREST_CLICK_COUNT', {
          destination: 'app_store',
          route: window.location.pathname,
          click_type: 'pinterest_to_appstore'
        });

        // Google Analytics gtag - четкие названия
        if (window.gtag) {
          // Pinterest маршрут - основное событие
          window.gtag('event', 'PINTEREST_ROUTE_CLICK', {
            event_category: 'PINTEREST_MARKETING',
            event_action: 'App_Store_Redirect',
            event_label: 'Pinterest_Route_To_AppStore',
            value: 1,
            custom_parameter_route: window.location.pathname
          });
          
          // Pinterest конверсия в App Store
          window.gtag('event', 'PINTEREST_CONVERSION', {
            event_category: 'CONVERSIONS',
            event_action: 'Pinterest_To_AppStore',
            event_label: 'Pinterest_Success',
            value: 1
          });
          
          // Pinterest счетчик
          window.gtag('event', 'PINTEREST_COUNT', {
            event_category: 'COUNTERS',
            event_action: 'Pinterest_Click_Count',
            event_label: window.location.pathname,
            value: 1
          });
        }

        // Google Tag Manager - четкие события
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'PINTEREST_ROUTE_REDIRECT',
            event_category: 'PINTEREST_MARKETING',
            event_action: 'Pinterest_Route_Redirect',
            event_label: 'Pinterest_Route_Success',
            page_path: window.location.pathname,
            redirect_type: 'PINTEREST_TO_PINTEREST',
            redirect_count: 1
          });
          
          // Pinterest счетчик для GTM
          window.dataLayer.push({
            event: 'PINTEREST_CLICK_COUNTER',
            category: 'PINTEREST_COUNTERS',
            action: 'Pinterest_Route_Click',
            label: 'PINTEREST_' + window.location.pathname,
            pinterest_click: 1
          });
        }

        console.log('Pinterest redirect tracked successfully');
      } catch (error) {
        console.error('Error tracking Pinterest redirect:', error);
      }
    };

    // Трек визита
    trackVisit();

    // Редирект через небольшую задержку для записи аналитики
    const redirectTimer = setTimeout(() => {
      window.location.href = APP_STORE_URL;
    }, 500);

    return () => clearTimeout(redirectTimer);
  }, [analytics]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#E60023',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        textAlign: 'center',
        padding: '2rem',
        maxWidth: '400px'
      }}>
        <div style={{
          width: '60px',
          height: '60px',
          margin: '0 auto 1rem',
          borderRadius: '50%',
          backgroundColor: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '30px'
        }}>
          📌
        </div>
        
        <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#fff',
          marginBottom: '0.5rem'
        }}>
          Redirecting to App Store
        </h1>
        
        <p style={{
          fontSize: '16px',
          color: 'rgba(255, 255, 255, 0.8)',
          marginBottom: '2rem',
          lineHeight: '1.5'
        }}>
          Taking you to download ChefKats AI...
        </p>

        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '1rem'
        }}>
          <div style={{
            width: '6px',
            height: '6px',
            backgroundColor: '#fff',
            borderRadius: '50%',
            margin: '0 3px',
            animation: 'bounce 1.4s ease-in-out infinite both'
          }} />
          <div style={{
            width: '6px',
            height: '6px',
            backgroundColor: '#fff',
            borderRadius: '50%',
            margin: '0 3px',
            animation: 'bounce 1.4s ease-in-out 0.16s infinite both'
          }} />
          <div style={{
            width: '6px',
            height: '6px',
            backgroundColor: '#fff',
            borderRadius: '50%',
            margin: '0 3px',
            animation: 'bounce 1.4s ease-in-out 0.32s infinite both'
          }} />
        </div>

        <a 
          href={APP_STORE_URL}
          style={{
            color: 'rgba(255, 255, 255, 0.8)',
            textDecoration: 'none',
            fontSize: '14px'
          }}
          onClick={() => {
            // Дополнительный трекинг клика по ссылке
            if (window.gtag) {
              window.gtag('event', 'manual_appstore_click_from_pinterest', {
                event_category: 'Pinterest Marketing',
                event_label: 'manual_redirect'
              });
            }
          }}
        >
          Open App Store manually
        </a>
      </div>

      <style jsx>{`
        @keyframes bounce {
          0%, 80%, 100% {
            transform: scale(0);
          }
          40% {
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );
};

export default PinterestRedirect;